import { cache } from "../constants/pwa";

export const isPwaInstalled = () => {
  return window.matchMedia("(display-mode: standalone)").matches;
};

export const pwaInstall = async (setIsInstall?: () => void) => {
  if (!cache["root"]) return;
  if (isPwaInstalled()) {
    alert("App is installed");
    return;
  }
  await cache["root"].prompt();
  cache["root"]?.userChoice.then(
    (choiceResult: { outcome: "accepted" | "dismissed" }) => {
      if (choiceResult.outcome === "accepted") {
        setIsInstall?.();
      }
    },
  );
};
